import { useQuery } from "@tanstack/react-query";
import { fetchApiGet } from "../../../../utils";
import { TtOrderMetadata } from "../types";

export interface ActiveOrderRow {
  guid_order_id: string;
  exchange_event_time: string;
  trading_account_name: string | null;
  user_name: string | null;
  instrument_name: string | null;
  buy_sell_type: string | null;
  order_quantity: string | null;
  order_uom_quantity: string | null;
  working_quantity: string | null;
  remaining_quantity: string | null;
  filled_quantity: string | null;
  limit_price: string | null;
  text_a: string | null;
  text_b: string | null;
  text_c: string | null;
  text_tt: string | null;
  metadata: TtOrderMetadata | null;
}

export interface ActiveOrdersResponse {
  snapshot_id: string | null;
  snapshot_taken_at: string | null;
  rows: ActiveOrderRow[];
}

export const ACTIVE_ORDERS_QUERY_KEY = ["risk", "brokerage", "tt", "v2", "active-orders"] as const;

export function useListActiveOrders(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: ACTIVE_ORDERS_QUERY_KEY,
    queryFn: () => fetchApiGet<ActiveOrdersResponse>("/brokerage/tt/v2/active-orders"),
    enabled: options?.enabled ?? true,
  });
}
